import View from "./views";
import Presenter from "./presenter";
import { ConnectComponent2 } from "util";

const states = [
  {
    name: "app.management.multilocality-sales-report",
    url: "/vendas-multilojas",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        name: "Vendas Multilojas",
        priority: 600,
        authorization: context =>
          context.user.allowed_companies_uuids.length > 1,
        state: "app.management.multilocality-sales-report"
      }
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/management/multilocality-sales-report/index.js